import { render } from "./BaseInfo.vue?vue&type=template&id=76ef99d4&scoped=true&ts=true"
import script from "./BaseInfo.vue?vue&type=script&lang=ts"
export * from "./BaseInfo.vue?vue&type=script&lang=ts"

import "./BaseInfo.vue?vue&type=style&index=0&id=76ef99d4&scoped=true&lang=scss"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ef99d4"]])

export default __exports__